import { useSelector } from 'react-redux'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import { selectHasToken, selectIsCAEmployee, selectIsImpersonating, selectPermissions, selectSecurityRoles } from '../redux/authSelectors'
import { Permission } from '../types'
import getHomeRoutePath from '../helpers/getHomeRoutePath'
import useAccessRulesQuery from '../hooks/useAccessRulesQuery'
import { useGetDashboardSettingsQuery } from '@/shared/api/services/legacyService'

interface Props extends RouteProps {
  authority?: Permission
  path: string;
}

export default function ProtectedRoute(props: Props) {
  const { path, exact, component, authority, ...rest } = props
  const permissions: Array<Permission> = useSelector(selectPermissions)
  const hasToken = useSelector(selectHasToken)
  const securityRoles = useSelector(selectSecurityRoles)
  const { isSuccess, data, isLoading } = useAccessRulesQuery()
  const { isSuccess: settingsSuccess, data: settingsData, isLoading: settingsLoading } = useGetDashboardSettingsQuery()
  const isImpersonating = useSelector(selectIsImpersonating)
  const defaultPath = getHomeRoutePath(permissions, securityRoles) ?? '/'
  
  if (hasToken && authority && !permissions.includes(authority)) {
    console.error('User does not have access to this route.')
    return <Redirect to={defaultPath} />
  }

  if (path.startsWith('/document')) {
    if (isSuccess && !data?.documents) return <Redirect to={defaultPath} />
    if (isLoading) return null
  }

  if (path.startsWith('/messages') && isImpersonating) {
    if (isSuccess && !data?.documents) return <Redirect to={defaultPath} />
    if (isLoading) return null
  }

  if (path.startsWith('/dashboard/onboarding')) {
    if (settingsSuccess && !settingsData?.enableClientOnboardingDashboard) return <Redirect to={defaultPath} />
    if (settingsLoading) return null
  }

  return (
    <Route
      path={path}
      exact={exact}
      component={component}
      {...rest}
    />
  )
}